export default __webpack_public_path__ + "static/software-development-company-peerbits-651219c805c7c2224a9280f5c300044e.png";